import { types } from "react-bricks/frontend";

// Hero components
import HeroText from "./heros/HeroText";
import HeroLanding from "./heros/HeroLanding";

// Section components
import IntroductionBlock from "./sections/IntroductionBlock";
import ImageCallout from "./sections/ImageCallout";
import StatsBar from "./sections/StatsBar";
import StatsBarItem from "./sections/StatsBarItem";
import { Accordion } from "./sections/Accordion";
import { AccordionItem } from "./sections/AccordionItem";
import { TextWithImage } from "./sections/TextWithImage";
import { Callback } from "./sections/Callback";
import { InfoCard } from "./cards/InfoCard";
import { InfoCardSection } from "./cards/InfoCardSection";
import TrustpilotSection from "./sections/TrustpilotSection";
import QuoteCarousel from "./sections/QuoteCarousel";
import { TestimonialItem } from "./sections/TestimonialItem";
import ButtonStrip from "./buttons/ButtonStrip";
import KeyResources from "./sections/KeyResources";
import ChecklistItem from "./common/ChecklistItem";

const bricks: types.Theme[] = [
  {
    themeName: "YuLife - Website",
    categories: [
      {
        categoryName: "Website bricks",
        bricks: [
          Accordion,
          AccordionItem,
          ButtonStrip,
          Callback,
          HeroLanding,
          HeroText,
          ImageCallout,
          InfoCard,
          InfoCardSection,
          IntroductionBlock,
          KeyResources,
          QuoteCarousel,
          StatsBar,
          StatsBarItem,
          TestimonialItem,
          TextWithImage,
          TrustpilotSection,
        ],
      },
      {
        categoryName: "Hidden",
        bricks: [ChecklistItem],
      },
    ],
  },
];

export default bricks;
